import angular from 'angular';

var SECURITY_HIDDEN_CLASS = 'no-access-feature';

angular.module('cloudX').directive('cxFeature', [
  '$rootScope',
  'checkFeature',
  'authService',
  function($rootScope, checkFeature, authService) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var security = '';
        var doCheck = function() {
          if (checkFeature(security)) element.removeClass(SECURITY_HIDDEN_CLASS);
          else element.addClass(SECURITY_HIDDEN_CLASS);
        };

        scope.$watch(attr.cxFeature, function(value) {
          security = value;
          doCheck();
        });

        var destroyer = $rootScope.$on('$cxAuthenticated', function() {
          doCheck();
        });
        scope.$on('$destroy', function() {
          destroyer();
        });

        authService.addOnNewToken(function(token) {
          doCheck();
        });
      },
    };
  },
]);
